// src/api.js (Axios version with default headers)

import axios from 'axios';

const BASE_URL = 'https://zort-chatai-api-gfdshtajd2aceeef.southeastasia-01.azurewebsites.net';
const apiKey = 'A0HvZ4q0qJIsIF22qr8W'; // Replace with your actual API key
export function getUserId() {
  const params = new URLSearchParams(window.location.search);
  const userIdFromQuery = params.get('userId');

  if (userIdFromQuery) {
    localStorage.setItem('chatUserId', userIdFromQuery);
    return userIdFromQuery;
  }

  return localStorage.getItem('chatUserId') || '';
}

export function setUserId(userId) {
  localStorage.setItem('chatUserId', userId);
}

// Create an Axios instance with default headers
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': apiKey
  }
});

api.interceptors.request.use((config) => {
  const userId = getUserId();
  if (userId) {
    config.headers.userId = userId;
  }
  return config;
});

export default api;
/**
 * Get all conversations
 * @returns {Promise<Array>}
 */
export const getConversations = async () => {
  try {
    const response = await api.get('/sessions?pageSize=100');
    return response.data.sessions || [];
  } catch (error) {
    console.error('Error fetching conversations:', error);
    return [];
  }
};

/**
 * Get messages in a specific session
 * @param {string} sessionId
 * @returns {Promise<Array>}
 */
export const getMessages = async (sessionId) => {
  try {
    const response = await api.get(`/sessions/${sessionId}/messages`);
    return response.data;
  } catch (error) {
    console.error('Error fetching messages:', error);
    return [];
  }
};

/**
 * Send a new message to a session
 * @param {string} userId
 * @param {string} question
 * @param {string} sessionId
 * @returns {Promise<Object|null>}
 */
export const sendMessage = async (question, sessionId, selectedModel) => {
  try {
    console.log('✅ sendMessage sessesId:', sessionId); // <-- Log full response object
    console.log('✅ selectedModel:', selectedModel); // <-- Log full response object
     let namespace = '';
     let ragUrl = '';
    switch (selectedModel) {
      case 'Gemini':
        ragUrl = '/gcp_embed_768/index-poc/gemini';
        break;
      case 'Claude':
        ragUrl = '/rag-claude';
        break;
      case 'Claude-Index':
        ragUrl = '/poc-index/rag-claude-poc-index';
        break;
      case 'Claude-POC':
        ragUrl = '/rag-claude-poc';
        break;
      case 'Claude|product':
        ragUrl = '/rag-claude';
        namespace = 'product';
        break;
      case 'Claude|api':
        ragUrl = '/rag-claude';
        namespace = 'api';
        break;
      case 'Claude|support':
        ragUrl = '/rag-claude';
        namespace = 'support';
        break;
      case 'Claude|sales':
        ragUrl = '/rag-claude';
        namespace = 'sales';
        break;
      case 'Claude-MNS':
        ragUrl = '/multiple-ns/claude';
        break;        
      case 'GPT|product':
        ragUrl = '/rag';
        namespace = 'product';
        break;
      case 'GPT|api':
        ragUrl = '/rag';
        namespace = 'api';
        break;
      case 'GPT|support':
        ragUrl = '/rag';
        namespace = 'support';
        break;
      case 'GPT|sales':
        ragUrl = '/rag';
        namespace = 'sales';
        break;
      case 'GPT-MNS':
        ragUrl = '/multiple-ns/gpt';
        break;
      default:
        ragUrl = '/rag';
        break;
    }
    console.log('✅ sendMessage Url:', ragUrl); // <-- Log full response object
    console.log('✅ sendMessage Namespace:', namespace); // <-- Log full response object
     const response = await api.post(ragUrl, {
      question,
      sessionId,
      namespace
    }, {
    timeout: 120000 // 30 วินาที
  });
    console.log('✅ sendMessage response:', response); // <-- Log full response object
    return response;
  } catch (error) {
    console.error('❌ Error in sendMessage:', error);
    throw error;
  }
};

  export const deleteSession = async (sessionId) => {
  try {
    const response = await api.delete(`/sessions/${sessionId}`);
    console.log('✅ delete Session response:', response); // <-- Log full response object
    return response.data;
  } catch (error) {
    console.error('Failed to delete session:', error);
    throw error;
  }
};
